import Navbar from '../components/Navbar';
import Footer2 from '../components/Footer2';
import ContentDownload from '../components/download/ContentDownload';

function Download() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <ContentDownload />
      </main>
      <Footer2 />
    </div>
  );
}

export default Download;
